import React, { useEffect, useState } from "react";
import { Formik, Form, FieldArray, Field, ErrorMessage, useFormik } from "formik";
import * as Yup from "yup";
import LoadCSSforfirstTime from "../../../../CloudStorage/LoadCSSforfirstTime";
import { disabledStyle } from "../../../Common/ClickDisable";
import LoginLoaderButton from "../../../Common/Loader/LoginLoaderButton";
import { useDispatch, useSelector } from "react-redux";
import { addAuction, updateAuction } from "../../../../redux/auction/action";
import CustomReactQuillDescription from "../../../Common/CustomeLabel/ReactQuill/CustomReactQuillDescription";
import DisplayFileProper from "../../../Common/FilesRelevent/DisplayFileProper";
import DownloadButton from "../../../Common/FilesRelevent/DownloadButton";
import { getDateFormate } from "../../../Common/AllDateTimeReleventFormate";
import CustomeDurationLabel from "../../../Common/CustomeLabel/CustomeDurationLabel";
import ActiveHTMLDescription from "../../../Common/CustomeLabel/ReactQuill/ActiveHTMLDescription";

// Added Imports for the Popup
import { Modal } from "reactstrap";
import ContractView from "../../../CustomComponents/ContractView";

import PopupContractPrivacyPolicy from "../../../Common/PopupContractPrivacyPolicy";
import SignContractInput from "../../../Common/SignContractInput";
import CloudStorage from "../../../../CloudStorage/CloudStorage";

const bxpDatatomap = [
  { title: "Price in $", name: "price", placeholder: "Enter total cost" },
];

const PricingTerms = ({ updateindex, bxpData, setActiveTab, setModalOpen, setModal }) => {
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  
  // State for popups and temporarily holding the main form data
  const [contractModal, setContractModal] = useState(false);
  const [privacyModal, setPrivacyModal] = useState(false);
  const [tempMainData, setTempMainData] = useState(null);

  // Fetching profile for auto-filling signature inputs
  const profile = useSelector(({ profile: { profiledata } }) => profiledata);

  const initialValues = {
    price: bxpData?.price || "",
    payment_type: bxpData?.payment_type || 2,
    terms: bxpData?.terms || "",
    milestones: bxpData?.milestones || [
      {
        title: "",
        duration: "",
        amount: "",
        files: ''
      },
    ],
  };

  const validationSchema = Yup.object().shape({
    price: Yup.string().required("Price is required"),
    payment_type: Yup.string().required("Payment terms are required"),
    terms: Yup.string(),
  });

  // Step 1: Intercept the main form submission to check if it's Add or Update
  const handleInitialSubmit = (values) => {
    if (updateindex !== null) {
      // --- UPDATE FLOW: Skip Contract Modal and dispatch directly ---
      setLoading(true);
      try {
        const updatedBxpData = {
          ...bxpData,
          price: values.price,
          payment_type: values.payment_type,
          terms: values.terms,
          milestones: values.milestones,
          // Fallback to profile names for the update since there is no sign step
          first_name: profile?.first_name || "", 
          last_name: profile?.last_name || "",   
          image: "image.png"
        };

        dispatch(updateAuction(updatedBxpData, setLoading));
        
        // Close relevant modals
        if(setModalOpen) setModalOpen(false);
        if(setModal) setModal(false);

      } catch (error) {
        console.error("Error updating BXP:", error);
      } finally {
        setTimeout(() => {
          setLoading(false);
        }, 1000);
      }
    } else {
      // --- ADD FLOW: Save data temporarily and open Contract Modal ---
      console.log("Main form values before opening contract modal:", values);
      setTempMainData(values);
      setContractModal(true);
    }
  };

  // Step 2: Formik configuration for the Signature Popup (Only used for Add)
  const signFormik = useFormik({
    initialValues: {
      first_name: profile?.first_name || "",
      last_name: profile?.last_name || "",
      agree: false,
    },
    validationSchema: Yup.object({
      first_name: Yup.string().required("First name is required"),
      last_name: Yup.string().required("Last name is required"),
      agree: Yup.boolean().oneOf([true], "You must agree to the terms"),
    }),
    onSubmit: async (signValues) => {
      setLoading(true);
      try {
        // Merge the main form data with the newly signed details
        const updatedBxpData = {
          ...bxpData,
          price: tempMainData.price,
          payment_type: tempMainData.payment_type,
          terms: tempMainData.terms,
          milestones: tempMainData.milestones,
          first_name: signValues.first_name, 
          last_name: signValues.last_name,   
          image: "image.png"
        };

        // We know updateindex is null here because of the earlier check, 
        // but kept the logic for safety
        if (updateindex !== null) {
          dispatch(updateAuction(updatedBxpData, setLoading));
        } else {
          dispatch(addAuction(updatedBxpData, setLoading));
          localStorage.removeItem("BSA_ADD_DRAFT");
        }

        // Close all modals sequentially
        setContractModal(false);
        if(setModalOpen) setModalOpen(false);
        if(setModal) setModal(false);
      } catch (error) {
        console.error("Error submitting BXP:", error);
      } finally {
        setTimeout(() => {
          setLoading(false);
        }, 1000);
      }
    },
  });

  const path = "Assets/scss/FirstTimeUsers.module.scss";
  useEffect(() => {
    LoadCSSforfirstTime(path);
  }, [path]);

  return (
    <div>
      {/* ---------------- Main Form ---------------- */}
      <Formik
        initialValues={initialValues}
        // validationSchema={validationSchema}
        onSubmit={handleInitialSubmit} // Checks Update vs Add
        enableReinitialize
      >
        {(formik) => (
          <Form>
            <div>
              {bxpDatatomap.map((prop, key) => {
                return (
                  <div key={key} className="d-flex flex-column price-flex">
                    <div className="price-duration" >
                      <h6>Item title</h6>
                      <h4>{bxpData?.title}</h4>
                    </div>
                    <div className="price-duration" >
                      <h6>Minimum bid</h6>
                      <h4>$ {bxpData?.min_bid}</h4>
                    </div>
                    {bxpData?.description && (
                      <div className="price-duration" style={{ width: '100%' }}>
                        <h6>Description</h6>
                        <ActiveHTMLDescription
                          value={bxpData?.description}
                          displyreadorless={true}
                        />
                      </div>
                    )}
                    <div className="price-duration" >
                      <h6>Item’s images</h6>
                      <>
                        {Array.isArray(bxpData?.files) && bxpData?.files.filter(item => item.status != 3)
                          .map((item, index) => (
                            <div key={index} className="image-container mb-0 col-md-5 p-0 mb-3">
                              <DisplayFileProper item={item} />
                              <DownloadButton file={item} />
                            </div>
                          ))
                        }</>
                    </div>
                    <div className="price-duration" >
                      <h6>Buy & Sell with Auction (BSA) type</h6>
                      <h4>{bxpData?.auction_type == 2 ? 'Incremental' : 'Sealed'}</h4>
                    </div>
                    <div className="price-duration" >
                      <h6>Buy & Sell with Auction (BSA) date</h6>
                      <h4>{getDateFormate(bxpData?.start_date)}</h4>
                    </div>
                    <div className="price-duration" >
                      <h6>Buy & Sell with Auction (BSA) duration</h6>
                      <h4> 
                        <CustomeDurationLabel
                          duration={bxpData?.duration}
                          duration_type={bxpData?.duration_type}
                        />
                      </h4>
                    </div>
                    <div className="price-duration" >
                      <h6>Buy & Sell with Auction (BSA) time</h6>
                      <h4>{bxpData?.start_time}</h4>
                    </div>
                    <div className="price-duration" >
                      <h6>Delivery type</h6>
                      <h4>{bxpData?.delivery_type_title ? bxpData?.delivery_type_title : "D2D (door to door)"}</h4>
                    </div>
                  </div>
                );
              })}
              <div className="button-container">
                <p
                  style={loading ? disabledStyle : {}}
                  className="prev-button w-100"
                  onClick={() => setActiveTab("WorkSamples")}
                >
                  Back
                </p>
                <button className="next-button w-100" type="submit" disabled={loading}>
                  {loading ? (
                    <LoginLoaderButton />
                  ) : updateindex !== null ? (
                    "Update and Publish"
                  ) : (
                    "Save and Publish"
                  )}
                </button>
              </div>
            </div>
          </Form>
        )}
      </Formik>

   
      {contractModal && (
        <Modal
          isOpen={contractModal}
          size="lg" // To give it width similar to your container-fluid
          className="modal-centered contract-modal contract"
          toggle={() => setContractModal(false)}
        >
          <div className="contract-sec p-4" id="capture-contract-section">
               <img
                          src={`${CloudStorage.cloudurl}/Assets/Images/project/contract-logo.svg`}
                          alt=""
                        />
            <div className="website-design mb-4">
              <ContractView type={'auction_agreement'} />
            </div>

            <form onSubmit={signFormik.handleSubmit}>
              <SignContractInput formik={signFormik} />

              <div className="checkbox mt-3">
                <input
                  type="checkbox"
                  id="agree"
                  name="agree"
                  checked={signFormik.values.agree}
                  readOnly // Replaced onChange to strictly control via onClick like original
                  onClick={() => {
                    if (!signFormik.values.agree) {
                      setPrivacyModal(true);
                    } else {
                      signFormik.setFieldValue("agree", !signFormik.values.agree);
                    }
                  }}
                />
                <label htmlFor="agree">
                  Yes, I understand and agree to Urxprt’s <span> Terms of Service</span>, 
                  including the <span> User Agreement</span> and <span>Privacy Policy</span>.
                </label>
                {signFormik.touched.agree && signFormik.errors.agree ? (
                  <div className="error text-danger">{signFormik.errors.agree}</div>
                ) : null}
              </div>

              <div className="submit-btn mt-4 d-flex justify-content-end" style={{ gap: "10px" }}>
                <button
                  type="button"
                  className="btn"
                  onClick={() => setContractModal(false)}
                >
                  Back
                </button>
                <button type="submit" className="btn post-btn" disabled={loading}>
                  {loading ? <LoginLoaderButton /> : "Accept & Publish"}
                </button>
              </div>
            </form>
          </div>
        </Modal>
      )}

      {/* ---------------- Privacy Policy Nested Modal ---------------- */}
      {privacyModal && (
        <Modal
          isOpen={privacyModal}
          keyboard={false}
          className="modal-width modal-centered popupmodal termsconditionmodal"
           modalClassName="ter-over"
        >
          <PopupContractPrivacyPolicy formik={signFormik} setModal={setPrivacyModal} />
        </Modal>
      )}
    </div>
  );
};

export default PricingTerms;